import moment from "moment";

import { OnSchedRest }       from "../OnSchedRest";
import { OnSchedUtils }      from "../utils";

export const GetAvailability = (element, date, timezoneName) => new Promise((resolve) => {
  const baseUrl = element.onsched.apiBaseUrl
               + '/availability/' 
               + element.params.serviceId 
               + '/' 
               + moment(date).format('YYYY-MM-DD') 
               + '/' 
               + moment(date).format('YYYY-MM-DD')
  
  let params = element.params;
  params.timezoneName = timezoneName ? timezoneName : moment.guess();
  params.dayAvailability = 100;
  params.dayAvailabilityStartDate = moment(date).startOf('month').format('YYYY-MM-DD');
  params.firstDayAvailable = true;

  const url = OnSchedUtils.FormatUrlParams(baseUrl, params);

  OnSchedRest.Get(url, response => {
    let data = response;
    data.availableTimes = response.availableTimes.map(t => ({...t, serviceId: response.serviceId, locationId: response.locationId}))

    if (element.params.resourceIds) {
      if (element.params.roundRobin || element.options.showDuplicateResourceTimes) {
        resolve(data);
      }
      else {
        const filteredResponse = OnSchedUtils.MatchResourceTimes(element, data);
        resolve(filteredResponse);
      }
    }
    else resolve(data);
  })
})


export const GetTimezones = (element, date) => new Promise(resolve => {
  const url = element.onsched.setupApiBaseUrl
            + '/companies/timezones/'
            + moment(date).format('YYYY-MM-DD');
  
  OnSchedRest.Get(url, resolve)
})